import React from 'react';
import { useDispatch } from 'react-redux';
import { AddAccountButtonsGroup } from '../../Profile/Accounts/components/AddAccountPreSelection/components/AddAccountButtonsGroup';
import { usePlaidLink } from '../../_hooks/plaid/usePlaidLink';
import { Wrapper } from './PlaidLinkAccountStyles';
import { setCurrentView } from '../UpsertAccountModalActions';
import { VIEWS } from '../UpsertAccountModalConstants';
import { setIsPlaidInfoMessageVisibility } from '../../Plaid/state/actions';

const PlaidLinkAccountView = ({
  onAddAccount,
  currentClient,
  onAccountLinked,
  onOpenAkoyaLinkManagementModal,
}) => {
  const dispatch = useDispatch();

  const { open: openPlaid, isLoading } = usePlaidLink({
    clientId: currentClient.Id,
    onStart: () => {
      dispatch(setCurrentView(VIEWS.LIST));
    },
    onSuccess: () => {
      dispatch(setIsPlaidInfoMessageVisibility(true));
      onAccountLinked();
    },
    onExit: () => {
      dispatch(setCurrentView(VIEWS.LIST));
    },
  });

  return (
    <Wrapper>
      <h2 className="accounts-workflow-link-institution-h2">Add your accounts</h2>

      <AddAccountButtonsGroup
        isLoading={isLoading}
        plaidOnClick={() => openPlaid()}
        manualOnClick={() => onAddAccount()}
        showExternalAccountProviders
        onOpenAkoyaLinkManagementModal={onOpenAkoyaLinkManagementModal}
      />
    </Wrapper>
  );
};

export default PlaidLinkAccountView;
